module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c084f92ee6ad75562dd28d51cd054c78.png";